import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { StateDropDown } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StateField = () => {
    const value = useBrokerDetailsStore((s) => s.businessAddress.state);
    const updateBusinessAddress = useBrokerDetailsStore((s) => s.updateBusinessAddress);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.BusinessAddressState);
    return (
        <>
            <StateDropDown
                id='cState'
                value={value}
                onChange={(v) => updateBusinessAddress({ state: v })}
                label='State'
                width={'auto'}
                required={isBroker}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
